<template>
  <div>
    <router-link
      :to="{ name: 'scalePercentage', params: { id: scalePercentage.id } }"
    >
      <span v-if="scalePercentageType">{{ scalePercentageType.name }}</span>
      <span v-if="!scalePercentageType">{{
        scalePercentage.scalepercentagetypeid
      }}</span>
    </router-link>
    <span v-if="fallback">
      &#160;
      <i>fallback</i>
    </span>
    <ScaleLitePercentage :id="scalePercentage.id" />
    <LineChart v-if="chartjs" :value="chartjs" />
  </div>
</template>

<script>
import LineChart from "@/components/quote/scales/LineChart";
import ScaleLitePercentage from "@/components/quote/scales/ScaleLitePercentage";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ScalePercentage",
  props: ["value", "surcharge", "scalePercentageTypesMap"],
  components: { LineChart, ScaleLitePercentage },
  computed: {
    fallback() {
      return this.value.scalePercentage ? false : true;
    },
    scalePercentage() {
      return this.fallback
        ? this.value.scalePercentageFallback
        : this.value.scalePercentage;
    },
    scalePercentageType() {
      return this.scalePercentageTypesMap
        ? this.scalePercentageTypesMap[
            this.scalePercentage.scalepercentagetypeid
          ]
        : undefined;
    }
  },
  data() {
    return {
      chartjs: null
    };
  },
  methods: {
    async fetchDataCollection() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/scalePercentages/${this.scalePercentage.id}/dataCollection`,
        { params: { surcharge: this.surcharge } }
      );
      // console.log(response.data);
      this.chartjs = response.data;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.fetchDataCollection();
      }
    }
  }
};
</script>

<style></style>